// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'folder';

export const Component = () => (
  <path d='M.957 3.005h8.141l.767 2.251c.144.431.479.67.91.67h12.787v16.715H.957V3.005ZM9.099 2H.958a.946.946 0 0 0-.67.288c-.192.24-.288.478-.288.718v19.636c0 .24.096.48.287.67a.946.946 0 0 0 .67.288h22.606a.94.94 0 0 0 .67-.288.946.946 0 0 0 .288-.67V5.927a.946.946 0 0 0-.287-.67.946.946 0 0 0-.67-.287H10.775l-.767-2.3C9.913 2.24 9.627 2 9.1 2Z' />
);

export const viewBox = '0 0 25 25';
